const FV = require('../../../components/form-validation/form-validation.script');
const options = require("./data/options")
export async function load() {
    try {

        const formEl = document
            .getElementById('etapa_3')
        await startForm(formEl)
        await FV
            .addMasksToView(formEl)
        // await FV.enableOrDisableFieldsByParams(formEl)

        // await feelUserInfo(formEl)


        return true
    } catch (err) {
        console.log('err', err)
        return err
    }
}

function startForm(formEl) {
    formEl
        .addEventListener('submit', function (evt) {
            evt.preventDefault()
            FV.clearErrosMessages(formEl)
            sendForm(formEl)
        })
}

async function sendForm(formEL) {

    if (FV.thisFormIsValid(formEL)) {

        const button = document.getElementById('send-button');

        if (!button.classList.contains('loading')) {
            button.classList.add('loading');
        }

        const bodyObject = await FV.getFormValues(formEL);

        try {
            const userType = formEL.getAttribute('userType')
            const userId = formEL.getAttribute('userId')
            const registerKey = formEL.getAttribute('registerKey')
            const selectedOption = options[userType + registerKey].options.find((el) => {
                return el.value == bodyObject.selTipo
            })

            if (selectedOption.isOutRoute && selectedOption.isOutRoute == true) {
                window.barba.go(`/${selectedOption.nextRoute}`);
            } else {
                window.barba.go(`/cadastro/${selectedOption.nextRoute}/${userId}`);
            }

            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }

        } catch (err) {
            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }

            alert(err)
        }

    }
}
